module.exports = __webpack_public_path__ + "static/media/iiitk_logo.753d23bb.png";